<template>
  <BaseRender
    class="company-field-mapping"
    showDefaultValue
    :loading="loading"
    :fieldTypeInfo="fieldTypeInfo"
    :fieldInfo="fieldInfo"
    :mappingList="mappingList"
    @save="handleSave"
  >
    <template #defaultValue="{ refName }">
      <el-input
        v-model="defaultValue"
        :ref="refName"
        :placeholder="$t(`${i18nPrefix}.placeholder.defaultValue`)"
        @focus="clearError(refName)"
      ></el-input>
    </template>
    <template #selfFieldRender="{ data }">
      <span class="self-company-name" :style="{ paddingLeft: `${15 * (data.level - 1)}px` }">{{ data.i18nName }}</span>
    </template>
    <template #otherFieldRender="{ data, refName }">
      <el-input
        v-model="data.value"
        class="other-company-name"
        :ref="refName"
        :placeholder="$t(`${i18nPrefix}.placeholder.inputFieldMappingValue`, { channelName, fieldTypeName })"
        @focus="clearError(refName)"
      ></el-input>
    </template>
  </BaseRender>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import channelId from '../channelId'
import mixin from '../mixin'
import { addI18nProperty } from '@/i18n'

export default {
  name: `channel-${channelId.job51}-fieldType-company`,
  mixins: [mixin],
  data () {
    return {
      mappingList: [],
      companyChildrenTree: []
    }
  },
  computed: {
    companyField () {
      return this.fieldInfo.company
    },
    defaultValue: {
      get () {
        return this.companyField?.default
      },
      set (value) {
        if (this.companyField) {
          this.companyField.default = value
        }
      }
    }
  },
  created () {
    this.refreshPageData()
  },
  methods: {
    ...mapActions('company', ['getCompanyChildrenTree']),
    async refreshPageData () {
      this.loading = true
      try {
        const resp = await this.getCompanyChildrenTree()
        if (resp) {
          const originDataMap = {}
          _.forEach(this.companyField.data_map_list, item => {
            originDataMap[item.key] = item
          })
          const selfCompany = resp.self
          const selfDataMap = originDataMap[`${selfCompany.id}`] || { key: `${selfCompany.id}`, value: null }
          const companyTree = resp.children
          addI18nProperty(resp.self, 'i18nName', 'cn_name', 'name')
          const mappingList = [{
            id: 1,
            self: selfCompany,
            other: selfDataMap
          }]
          const children = companyTree[selfCompany.id]
          if (children && children.length > 0) {
            this.formatCompanyData(mappingList, originDataMap, companyTree, children)
          }
          this.companyChildrenTree = resp
          this.mappingList = mappingList
        }
      } finally {
        this.loading = false
      }
    },
    handleSave () {
      if (!this.defaultValue) {
        this.setError(['defaultValue'])
        return
      }
      this.companyField.data_source = 'COMPANY'
      this.companyField.data_key_path = 'id'
      const mappingList = []
      _.forEach(this.mappingList, item => {
        if (item.other.value) {
          mappingList.push(item.other)
        }
      })
      this.companyField.data_map_list = mappingList
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
.company-field-mapping {
  ::v-deep {
    .el-table {
      .el-table__body {
        .self-field {
          text-align: left;

          .cell {
            padding-right: 5px;
          }
        }

        .other-field {
          .other-company-name {
            .el-input__inner {
              padding: 0 8px;
            }
          }
        }
      }
    }
  }

}
</style>
